import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { ScreenLoader } from '@/shared/components/ScreenLoader';
import { useUserStore } from '@/entities/user/store';

export const CallbackLayout = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useUserStore();

  useEffect(() => {
    // If already authenticated (e.g. from OAuth callback), go to the
    // home landing (/dashboard) — Soteria prompt is the entry verb.
    if (isAuthenticated) {
      navigate({ to: '/dashboard', replace: true });
    } else {
      // Not authenticated — redirect to login
      navigate({ to: '/login', replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <ScreenLoader text="Syncing profile..." className="h-[calc(90vh-50px)]" />
  );
};
